/**
 * Bluebird Co cart add-ons: one-tap add from the drawer or cart page, then let the theme
 * refresh itself through its own cart change event.
 */
(() => {
  document.addEventListener('click', async (evt) => {
    const button = evt.target.closest('[data-bb-addon-add]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    const item = button.closest('.bb-cart-addons__item');
    const select = item ? item.querySelector('.bb-cart-addons__select') : null;
    const variantId = Number(select ? select.value : button.dataset.variantId);
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    try {
      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error(response.status);
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    } catch (error) {
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
    }
  });
})();
